/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { checkLiked, deleteLike, registerLike } from '@/lib/like'
import { handleUserBehaviorWithoutPrice } from '@/lib/user_behavior/client'
import Image from 'next/image'
import { useEffect, useState } from 'react'

type LikeButtonProps = {
  service_id: string
  item_id: number
  liked: boolean
  count?: number
}

export const LikeButton: React.FC<LikeButtonProps> = ({
  service_id,
  item_id,
  liked,
  count: initialCount = 0
}) => {
  const [isLiked, setIsLiked] = useState(liked)
  const [likeCount, setLikeCount] = useState<number>(initialCount)

  useEffect(() => {
    const IsLiked = async () => {
      try {
        const res = await checkLiked(service_id, item_id)
        setIsLiked(res)
      } catch (error) {
        console.error(error)
      }
    }
    IsLiked()
  }, [service_id, item_id, liked])

  return (
    <div className="absolute right-5 bottom-28">
      <div className="bg-white rounded-full w-16 h-16 flex flex-col items-center justify-center">
        {isLiked ? (
          <>
            <Image
              alt="いいね！済み"
              src={'/heart.svg'}
              width={20}
              height={20}
              onClick={async () => {
                await deleteLike(service_id, item_id)
                setIsLiked(false)
                setLikeCount(prev => prev - 1)
              }}
              unoptimized
            />
            {likeCount >= 10 && (
              <span className="text-xs mt-1 text-gray-600">{likeCount}</span>
            )}
          </>
        ) : (
          <>
            <Image
              src={'/heart-gray.svg'}
              alt="いいね！"
              width={20}
              height={20}
              onClick={async () => {
                await registerLike(service_id, item_id)
                await handleUserBehaviorWithoutPrice(item_id, 'favorite')
                setIsLiked(true)
                setLikeCount(prev => prev + 1)
              }}
              unoptimized
            />
            {likeCount >= 10 && (
              <span className="text-xs mt-1 text-gray-600">{likeCount}</span>
            )}
          </>
        )}
      </div>
    </div>
  )
}
